import * as React from 'react';
import { snap, visualize } from 'storybook-snapper';
import { StripCard, Text, TextTypography } from '..';
import { classes } from './StripCard.visual.st.css';

const imageComponent = (width = 550, height = 322) => (
  <div
    style={{
      height: '100%',
      backgroundImage: `url(https://static.wixstatic.com/media/f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg/v1/fill/w_${width},h_${height},al_c,lg_1,q_80,enc_auto/f77a29_e163ea53eab341b48c4edd7049f290f1~mv2.jpg)`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    }}
  />
);

const StripCardDefault = () => {
  return (
    <StripCard
      media={imageComponent(100, 100)}
      info={<Text typography={TextTypography.smallTitle}>STRIP</Text>}
    />
  );
};

const StripCardInformation = () => {
  return (
    <StripCard
      info={
        <div>
          <Text tagName="div" typography={TextTypography.smallTitle}>
            ONLY INFO
          </Text>
          <Text typography={TextTypography.runningText}>
            The content spreads across the Card
          </Text>
        </div>
      }
    />
  );
};

const StripCardMinHeight = () => {
  return (
    <StripCard
      info={
        <Text typography={TextTypography.runningText}>Minimum Height 92px</Text>
      }
    />
  );
};

const StripCardRoundMedia = () => {
  return (
    <StripCard
      media={imageComponent(100, 100)}
      roundMedia
      info={
        <div>
          <Text tagName="div" typography={TextTypography.smallTitle}>
            ROUND MEDIA
          </Text>
          <Text typography={TextTypography.runningText}>
            Media container is rounded
          </Text>
        </div>
      }
    />
  );
};

const StripCardWithoutSidePadding = () => {
  return (
    <StripCard
      media={imageComponent(100, 100)}
      sidePadding={false}
      info={
        <div>
          <Text tagName="div" typography={TextTypography.smallTitle}>
            WITHOUT SIDE PADDING
          </Text>
          <Text typography={TextTypography.runningText}>
            Side padding set to 0px
          </Text>
        </div>
      }
    />
  );
};

const StripCardWithoutImage = () => {
  return (
    <StripCard
      media={<div />}
      info={
        <div>
          <Text tagName="div" typography={TextTypography.smallTitle}>
            MEDIA NOT AVAILABLE
          </Text>
        </div>
      }
    />
  );
};

const StripCardWithStyleOverrides = () => {
  return (
    <StripCard
      className={classes.root}
      media={<div />}
      info={
        <div>
          <Text tagName="div" typography={TextTypography.smallTitle}>
            With Style Overrides
          </Text>
        </div>
      }
    />
  );
};

visualize('StripCard', () => {
  snap('default layout', <StripCardDefault />);
  snap('information strip', <StripCardInformation />);
  snap('minimum height', <StripCardMinHeight />);
  snap('round media', <StripCardRoundMedia />);
  snap('without side padding', <StripCardWithoutSidePadding />);
  snap('without image', <StripCardWithoutImage />);
  snap('with style overrides', <StripCardWithStyleOverrides />);
});
